import { RouteTableColumn } from '../route-function-report/route-analysis-report/route-analysis-report.models';

export const SERVICE_DELIVERY_SUMMARY_COLUMNS: RouteTableColumn[] = [
  { field: 'strfullName', title: 'نام' },
  { field: 'displayPlate', title: 'پلاک' },
  { field: 'iCount', title: 'تعداد', numeric: true, totalField: 'iCount' },
  { field: 'strTime', title: 'مدت', totalField: 'iTime', totalDuration: true },
  { field: 'fKm', title: 'پیمایش (متر)', numeric: true, totalField: 'fKm', unit: 'متر' },
];
export const SERVICE_DELIVERY_DETAIL_COLUMNS: RouteTableColumn[] = [
  { field: 'strDate', title: 'تاریخ' },
  { field: 'strSTime', title: 'ساعت شروع' },
  { field: 'strETime', title: 'ساعت پایان' },
  { field: 'strTime', title: 'مدت حرکت', totalField: 'iTime', totalDuration: true },
  { field: 'fKm', title: 'پیمایش (متر)', numeric: true, totalField: 'fKm', unit: 'متر' },
];
